module.exports = __webpack_public_path__ + "img/Ometz.9ffc1a96.png";